// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: sticky;
  top: 0;
  z-index: 900;
  background: #fff;
  border-bottom: 1px solid #EBEBEB;
  transition: box-shadow 0.2s ease;
}
.navbar.scrolled {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
body.dark-mode .navbar {
  background: #111827;
  border-bottom-color: #1F2937;
}
.navbar .container {
  padding-top: 0;
  padding-bottom: 0;
}
.navbar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  gap: 24px;
}
.navbar__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  flex-shrink: 0;
}
.navbar__logo {
  height: 32px;
  width: auto;
}
.navbar__brand-name {
  font-size: 18px;
  font-weight: 800;
  color: #1B2B4B;
  letter-spacing: -0.03em;
}
body.dark-mode .navbar__brand-name {
  color: #F9FAFB;
}
.navbar__links {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}
@media (max-width: 900px) {
  .navbar__links {
    display: none;
    position: fixed;
    inset: 72px 0 0 0;
    background: #fff;
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 4px;
    overflow-y: auto;
    border-top: 1px solid #EBEBEB;
    z-index: 900;
  }
  body.dark-mode .navbar__links {
    background: #111827;
    border-top-color: #1F2937;
  }
  .navbar__links--open {
    display: flex;
  }
}
.navbar__link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
}
.navbar__link:hover {
  background: #F3F4F6;
  color: #1B2B4B;
}
body.dark-mode .navbar__link {
  color: #D1D5DB;
}
body.dark-mode .navbar__link:hover {
  background: #1F2937;
  color: #F9FAFB;
}
@media (max-width: 900px) {
  .navbar__link {
    padding: 12px 16px;
    border-radius: 10px;
    font-size: 15px;
  }
}
.navbar__icon-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
}
.navbar__icon-btn:hover {
  background: #F3F4F6;
  color: #1B2B4B;
}
body.dark-mode .navbar__icon-btn {
  color: #D1D5DB;
}
body.dark-mode .navbar__icon-btn:hover {
  background: #1F2937;
  color: #F9FAFB;
}
@media (max-width: 900px) {
  .navbar__icon-btn {
    padding: 12px 16px;
    border-radius: 10px;
    font-size: 15px;
    width: 100%;
    justify-content: flex-start;
  }
}
.navbar__user-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 156px;
  padding: 5px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 24px;
  background: #f8fafc;
  color: #0F1C32;
  cursor: pointer;
  text-align: left;
}
.navbar__user-avatar {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  place-items: center;
  border-radius: 50%;
  background: #EEF2F8;
  color: #1B2B4B;
  font-size: 11px;
  font-weight: 750;
}
.navbar__user-copy {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  line-height: 1.2;
}
.navbar__user-copy strong, .navbar__user-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.navbar__user-copy strong {
  font-size: 12px;
  font-weight: 650;
}
.navbar__user-copy small {
  margin-top: 2px;
  color: #94A3B8;
  font-size: 9px;
}
.navbar__cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border: none;
  border-radius: 8px;
  background: #1B2B4B;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  white-space: nowrap;
}
.navbar__cta:hover {
  background: rgb(6.3529411765%, 10.1176470588%, 17.6470588235%);
}
.navbar__cta:active {
  transform: scale(0.98);
}
@media (max-width: 900px) {
  .navbar__cta {
    width: 100%;
    justify-content: center;
    padding: 13px 18px;
    font-size: 15px;
  }
}
.navbar__dropdown {
  position: relative;
}
@media (max-width: 900px) {
  .navbar__dropdown {
    width: 100%;
  }
}
.navbar__panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 220px;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 14px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.14);
  overflow: hidden;
  animation: panelIn 0.15s ease;
  z-index: 999;
}
body.dark-mode .navbar__panel {
  background: #1F2937;
  border-color: #374151;
}
@keyframes panelIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 900px) {
  .navbar__panel {
    position: static;
    box-shadow: none;
    border: 1px solid #E5E7EB;
    border-radius: 10px;
    margin-top: 4px;
    animation: none;
  }
}
.navbar__panel--user-menu {
  min-width: 230px;
  border-radius: 14px;
}
.navbar__panel--user-menu .navbar__panel-section {
  padding: 6px;
}
.navbar__panel--user-menu .navbar__panel-item {
  min-height: 42px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
}
.navbar__panel-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px 10px;
  font-size: 13px;
  font-weight: 700;
  color: #111827;
  border-bottom: 1px solid #F3F4F6;
}
body.dark-mode .navbar__panel-header {
  color: #F9FAFB;
  border-bottom-color: #374151;
}
.navbar__panel-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #F3F4F6;
}
body.dark-mode .navbar__panel-user {
  border-bottom-color: #374151;
}
.navbar__panel-user .avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #1B2B4B;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.navbar__panel-user .info .name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
body.dark-mode .navbar__panel-user .info .name {
  color: #F9FAFB;
}
.navbar__panel-user .info .role {
  font-size: 11px;
  color: #6B7280;
  text-transform: capitalize;
}
body.dark-mode .navbar__panel-user .info .role {
  color: #9CA3AF;
}
.navbar__panel-section {
  padding: 6px;
}
.navbar__panel-section-title {
  padding: 6px 10px 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9CA3AF;
}
.navbar__panel-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 13.5px;
  font-weight: 500;
  color: #374151;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.12s;
}
.navbar__panel-item:hover {
  background: #F9FAFB;
}
body.dark-mode .navbar__panel-item {
  color: #D1D5DB;
}
body.dark-mode .navbar__panel-item:hover {
  background: #111827;
}
.navbar__panel-item--active {
  background: #EEF2F8;
  color: #1B2B4B;
  font-weight: 600;
}
.navbar__panel-item--danger {
  color: #DC2626;
}
.navbar__panel-item--danger:hover {
  background: #FEF2F2;
}
.navbar__currency-item {
  justify-content: flex-start;
  gap: 8px;
}
.navbar__currency-item .sym {
  font-size: 13px;
  font-weight: 700;
  color: #C9A84C;
  min-width: 20px;
}
.navbar__currency-item .code {
  font-weight: 600;
  font-size: 13px;
}
.navbar__currency-item .name {
  font-size: 12px;
  color: #9CA3AF;
  flex: 1 1;
}
.navbar__currency-item .check {
  margin-left: auto;
  color: #16A34A;
  font-weight: 700;
}
.navbar__panel-divider {
  height: 1px;
  background: #F3F4F6;
  margin: 4px 0;
}
body.dark-mode .navbar__panel-divider {
  background: #374151;
}
.navbar__mobile-toggle {
  display: none;
  border: none;
  background: transparent;
  color: #374151;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  transition: background 0.15s;
}
.navbar__mobile-toggle:hover {
  background: #F3F4F6;
}
body.dark-mode .navbar__mobile-toggle {
  color: #D1D5DB;
}
@media (max-width: 900px) {
  .navbar__mobile-toggle {
    display: flex;
    align-items: center;
  }
}

.navbar {
  position: sticky;
  top: 0;
  z-index: 200;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid #E2E8F0;
  transition: all 0.25s ease;
}
body.dark-mode .navbar {
  background: rgba(9, 17, 30, 0.97);
  border-bottom-color: #1E3055;
}
.navbar .container {
  padding-top: 0;
  padding-bottom: 0;
}
.navbar__inner {
  display: flex;
  align-items: center;
  height: 64px;
  gap: 4px;
}
.navbar__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  flex-shrink: 0;
  margin-right: auto;
  transition: opacity 0.18s ease;
}
.navbar__brand:hover {
  opacity: 0.85;
}
.navbar__logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
}
.navbar__brand-name {
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #1B2B4B;
}
body.dark-mode .navbar__brand-name {
  color: #C9A84C;
}
.navbar__link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border-radius: 10px;
  color: #64748B;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.18s ease;
}
body.dark-mode .navbar__link {
  color: #94A3B8;
}
.navbar__link:hover {
  color: #1B2B4B;
  background: #EEF2F8;
}
body.dark-mode .navbar__link:hover {
  color: #F1F5F9;
  background: #1E2F4D;
}
.navbar__link svg {
  flex-shrink: 0;
}
.navbar__cta {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 10px;
  background: #1B2B4B;
  color: white;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  border: none;
  cursor: pointer;
  transition: all 0.18s ease;
  white-space: nowrap;
}
.navbar__cta:hover {
  background: #C9A84C;
  box-shadow: 0 4px 20px rgba(201, 168, 76, 0.35);
  transform: translateY(-1px);
}
body.dark-mode .navbar__cta {
  background: #C9A84C;
  color: #1B2B4B;
}
body.dark-mode .navbar__cta:hover {
  background: #B8953D;
}
.navbar__icon-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 10px;
  border-radius: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: #64748B;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.18s ease;
}
body.dark-mode .navbar__icon-btn {
  color: #94A3B8;
}
.navbar__icon-btn:hover {
  color: #1B2B4B;
  background: #EEF2F8;
}
body.dark-mode .navbar__icon-btn:hover {
  color: #F1F5F9;
  background: #1E2F4D;
}
.navbar__dropdown {
  position: relative;
}
.navbar__auth-dropdown {
  margin-left: 10px;
}
.navbar__panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12);
  z-index: 500;
  overflow: hidden;
  animation: navDropdown 0.15s ease;
  min-width: 240px;
}
[dir=rtl] .navbar__panel {
  right: auto;
  left: 0;
}
body.dark-mode .navbar__panel {
  background: #0F1C32;
  border-color: #1E3055;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.6);
}
.navbar__panel-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #1B2B4B;
  color: white;
  font-size: 13px;
  font-weight: 600;
}
.navbar__panel-header svg {
  opacity: 0.85;
}
.navbar__panel-user {
  padding: 16px;
  background: linear-gradient(135deg, #1B2B4B, #0F1C32);
  color: white;
  display: flex;
  align-items: center;
  gap: 12px;
}
.navbar__panel-user .avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
}
.navbar__panel-user .info .name {
  font-weight: 600;
  font-size: 15px;
  line-height: 1.3;
}
.navbar__panel-user .info .role {
  font-size: 11px;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-top: 2px;
}
.navbar__panel-section {
  padding: 8px;
}
.navbar__panel-section-title {
  font-size: 10px;
  font-weight: 700;
  color: #94A3B8;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 6px 8px 4px;
}
body.dark-mode .navbar__panel-section-title {
  color: #94A3B8;
}
.navbar__panel-divider {
  height: 1px;
  background: #E2E8F0;
  margin: 4px 0;
}
body.dark-mode .navbar__panel-divider {
  background: #1E3055;
}
.navbar__panel-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border-radius: 8px;
  color: #0F1C32;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  background: none;
  border: none;
  width: 100%;
  cursor: pointer;
  transition: all 0.18s ease;
  white-space: nowrap;
}
body.dark-mode .navbar__panel-item {
  color: #F1F5F9;
}
.navbar__panel-item:hover {
  background: #EEF2F8;
  color: #1B2B4B;
}
body.dark-mode .navbar__panel-item:hover {
  background: #1E2F4D;
  color: #F1F5F9;
}
.navbar__panel-item--danger {
  color: #DC2626;
}
body.dark-mode .navbar__panel-item--danger {
  color: #f87171;
}
.navbar__panel-item--danger:hover {
  background: rgba(220, 38, 38, 0.06);
  color: #DC2626;
}
.navbar__currency-item {
  display: grid;
  grid-template-columns: 26px 44px 1fr 18px;
  align-items: center;
  gap: 8px;
}
.navbar__currency-item .sym {
  font-weight: 700;
  font-size: 0.95rem;
}
.navbar__currency-item .code {
  font-weight: 600;
}
.navbar__currency-item .name {
  font-size: 11px;
  color: #94A3B8;
}
body.dark-mode .navbar__currency-item .name {
  color: #94A3B8;
}
.navbar__currency-item .check {
  color: #C9A84C;
  font-weight: 700;
}
.navbar__panel-item--active {
  background: #EEF2F8;
}
body.dark-mode .navbar__panel-item--active {
  background: #1E2F4D;
}
.navbar__mobile-toggle {
  display: none;
  background: none;
  border: none;
  color: #0F1C32;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
}
body.dark-mode .navbar__mobile-toggle {
  color: #F1F5F9;
}
@media (max-width: 768px) {
  .navbar__mobile-toggle {
    display: flex;
  }
}
.navbar__links {
  display: flex;
  align-items: center;
  gap: 2px;
}
@media (max-width: 768px) {
  .navbar__links {
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    background: white;
    border-bottom: 1px solid #E2E8F0;
    padding: 8px 16px 16px;
    gap: 2px;
    display: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.09);
  }
  .navbar__links--open {
    display: flex;
  }
  body.dark-mode .navbar__links {
    background: #0F1C32;
    border-bottom-color: #1E3055;
  }
  .navbar__links .navbar__panel {
    position: static;
    border: 1px solid #E2E8F0;
    box-shadow: none;
    margin-top: 4px;
    border-radius: 10px;
  }
  .navbar__links .navbar__auth-dropdown {
    margin-left: 0;
  }
}
.navbar {
  position: sticky;
  top: 0;
}

@keyframes navDropdown {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
html[dir=rtl] .navbar__brand {
  margin-right: 0;
  margin-left: auto;
}
html[dir=rtl] .navbar__links {
  direction: rtl;
}
html[dir=rtl] .navbar__panel-item, html[dir=rtl] .navbar__panel-header {
  text-align: start;
}

.navbar.navbar--authenticated .navbar__brand {
  margin-right: 24px;
}
.navbar.navbar--authenticated .navbar__links {
  flex: 1 1;
}
.navbar.navbar--authenticated .navbar__utility-start {
  margin-left: auto;
}
@media (max-width: 768px) {
  .navbar.navbar--authenticated .navbar__brand {
    margin-right: auto;
  }
  .navbar.navbar--authenticated .navbar__utility-start {
    margin-left: 0;
  }
}

.navbar.navbar--reference {
  box-sizing: border-box;
  width: 100%;
  height: 96px;
  min-height: 96px;
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
.navbar.navbar--reference .container {
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  padding: 24px 32px;
}
.navbar.navbar--reference .navbar__inner {
  width: 100%;
  max-width: 1376px;
  height: 48px;
  gap: 10px;
  justify-content: space-between;
}
.navbar.navbar--reference .navbar__brand {
  margin-right: 30px;
}
.navbar.navbar--reference .navbar__links {
  flex: 1 1;
  height: 48px;
  gap: 40px;
}
.navbar.navbar--reference .navbar__link {
  height: 48px;
  padding: 15px 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
}
.navbar.navbar--reference .navbar__link--active {
  color: #2E8CC9;
}
.navbar.navbar--reference .navbar__link:hover,
.navbar.navbar--reference .navbar__link:focus-visible {
  background: transparent;
  color: #2E8CC9;
  box-shadow: none;
}
.navbar.navbar--reference .navbar__cta {
  box-sizing: border-box;
  width: 137px;
  height: 48px;
  min-height: 48px;
  margin-left: auto;
  padding: 16px 24px;
  gap: 10px;
  border-radius: 100px;
  background: var(--CS-Blue-main, #2E86C9);
  color: #FFFFFF;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
}
.navbar.navbar--reference .navbar__cta:hover {
  background: #2477B7;
  color: #FFFFFF;
}
@media (max-width: 768px) {
  .navbar.navbar--reference {
    height: 72px;
    min-height: 72px;
  }
  .navbar.navbar--reference .container {
    padding: 12px 20px;
  }
  .navbar.navbar--reference .navbar__inner {
    height: 48px;
  }
  .navbar.navbar--reference .navbar__brand {
    margin-right: auto;
  }
  .navbar.navbar--reference .navbar__links {
    top: 72px;
  }
  .navbar.navbar--reference .navbar__cta {
    width: 100%;
    min-height: 44px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;EACA,gCAAA;AAFF;AAIE;EAAa,0CAAA;AADf;AAGE;EACE,mBAAA;EACA,4BAAA;AADJ;AAIE;EAAa,cAAA;EAAgB,iBAAA;AAA/B;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,SAAA;AAAJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;AAFJ;AAKE;EACE,YAAA;EACA,WAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,cC1CgB;ED2ChB,uBAAA;AAJJ;AAMI;EAAmB,cAAA;AAHvB;AAOE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AALJ;AAOI;EANF;IAOI,aAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,sBAAA;IACA,oBAAA;IACA,aAAA;IACA,QAAA;IACA,gBAAA;IACA,6BAAA;IACA,YAAA;EAJJ;EAMI;IAAmB,mBAAA;IAAqB,yBAAA;EAF5C;EAII;IAAU,aAAA;EADd;AACF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yCAAA;EACA,mBAAA;AAFJ;AAII;EAAU,mBAAA;EAAqB,cCvFf;ADuFpB;AAEI;EAAmB,cAAA;AACvB;AADuC;EAAU,mBAAA;EAAqB,cAAA;AAKtE;AAHI;EAjBF;IAkBI,kBAAA;IACA,mBAAA;IACA,eAAA;EAMJ;AACF;AAFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yCAAA;EACA,mBAAA;AAIJ;AAFI;EAAU,mBAAA;EAAqB,cClHf;ADwHpB;AAJI;EAAmB,cAAA;AAOvB;AAPuC;EAAU,mBAAA;EAAqB,cAAA;AAWtE;AATI;EAnBF;IAoBI,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;IACA,2BAAA;EAYJ;AACF;AATE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cCrHgB;EDsHhB,eAAA;EACA,gBAAA;AAWJ;AARE;EAAiB,aAAA;EAAe,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,mBAAA;EAAqB,kBAAA;EAAoB,mBC3IlG;ED2I8H,cC7I9H;ED6IqJ,eAAA;EAAiB,gBAAA;AAoB1L;AAnBE;EAAe,aAAA;EAAe,YAAA;EAAc,SAAA;EAAS,sBAAA;EAAwB,gBAAA;AA0B/E;AAzBE;EAA0C,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AA8BvF;AA7BE;EAAsB,eAAA;EAAiB,gBAAA;AAiCzC;AAhCE;EAAqB,eAAA;EAAiB,cC5HpB;ED4HwC,cAAA;AAqC5D;AAlCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBC3JgB;ED4JhB,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,4CAAA;EACA,mBAAA;AAoCJ;AAlCI;EAAU,8DAAA;AAqCd;AApCI;EAAW,sBAAA;AAuCf;AArCI;EAlBF;IAkB8B,WAAA;IAAa,uBAAA;IAAyB,kBAAA;IAAoB,eAAA;EA4CxF;AACF;AAzCE;EACE,kBAAA;AA2CJ;AAzCI;EAHF;IAG8B,WAAA;EA6C9B;AACF;AA1CE;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;AA4CJ;AA1CI;EAAmB,mBAAA;EAAqB,qBAAA;AA8C5C;AA5CI;EACE;IAAO,UAAA;IAAY,2BAAA;EAgDvB;EA/CI;IAAO,UAAA;IAAY,wBAAA;EAmDvB;AACF;AAjDI;EApBF;IAqBI,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,mBAAA;IACA,eAAA;IACA,eAAA;EAoDJ;AACF;AAjDE;EAAsB,gBAAA;EAAkB,mBAAA;AAqD1C;AApDE;EAA6C,YAAA;AAuD/C;AAtDE;EAA0C,gBAAA;EAAkB,kBAAA;EAAoB,kBAAA;EAAoB,eAAA;AA4DtG;AA1DE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;AA4DJ;AA1DI;EAAmB,cAAA;EAAgB,4BAAA;AA8DvC;AA3DE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AA6DJ;AA3DI;EAAmB,4BAAA;AA8DvB;AA5DI;EACE,WAAA;EAAa,YAAA;EACb,kBAAA;EACA,mBC5Oc;ED6Od,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EACpC,cAAA;AAiEN;AA7DM;EAAQ,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAkEjD;AAlEiE;EAAmB,cAAA;AAqEpF;AApEM;EAAQ,eAAA;EAAiB,cAAA;EAAgB,0BAAA;AAyE/C;AAzE2E;EAAmB,cAAA;AA4E9F;AAxEE;EACE,YAAA;AA0EJ;AAvEE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAyEJ;AAtEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;AAwEJ;AAtEI;EAAU,mBAAA;AAyEd;AAxEI;EAAmB,cAAA;AA2EvB;AA3EuC;EAAU,mBAAA;AA8EjD;AA5EI;EAAY,mBCrRI;EDqRwB,cCvRxB;EDuR+C,gBAAA;AAiFnE;AA/EI;EAAY,cAAA;AAkFhB;AAlFgC;EAAU,mBAAA;AAqF1C;AAlFE;EACE,2BAAA;EACA,QAAA;AAoFJ;AAlFI;EAAO,eAAA;EAAiB,gBAAA;EAAkB,cC3R1B;ED2R8C,eAAA;AAwFlE;AAvFI;EAAQ,gBAAA;EAAkB,eAAA;AA2F9B;AA1FI;EAAQ,eAAA;EAAiB,cAAA;EAAgB,SAAA;AA+F7C;AA9FI;EAAS,iBAAA;EAAmB,cCtQZ;EDsQmC,gBAAA;AAmGvD;AAhGE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;AAkGJ;AAhGI;EAAmB,mBAAA;AAmGvB;AA/FE;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;AAiGJ;AA/FI;EAAU,mBAAA;AAkGd;AAhGI;EAAmB,cAAA;AAmGvB;AAjGI;EAdF;IAc8B,aAAA;IAAe,mBAAA;EAsG7C;AACF;;AAlGA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;EACA,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,0BChRiB;ADqXnB;AAnGE;EACE,iCAAA;EACA,4BCtSkB;AD2YtB;AAlGE;EAAa,cAAA;EAAgB,iBAAA;AAsG/B;AAnGE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;AAqGJ;AAjGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,8BAAA;AAmGJ;AAlGI;EAAU,aAAA;AAqGd;AAlGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAoGJ;AAjGE;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cCjXgB;ADodpB;AAlGI;EAAmB,cC7WH;ADkdpB;AAjGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBCrUe;EDsUf,cCxWgB;EDyWhB,eCnTmB;EDoTnB,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;AAmGJ;AAjGI;EAAmB,cC/VD;ADmctB;AAlGI;EACE,cCzYc;ED0Yd,mBCxYc;AD4epB;AAnGM;EAAmB,cCrWH;EDqWsB,mBCtWtB;AD6ctB;AApGI;EAAM,cAAA;AAuGV;AAnGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBCjWe;EDkWf,mBCxZgB;EDyZhB,YAAA;EACA,eChVmB;EDiVnB,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;AAqGJ;AAnGI;EACE,mBC9Zc;ED+Zd,+CChWW;EDiWX,2BAAA;AAqGN;AAlGI;EACE,mBCpac;EDqad,cC1ac;AD8gBpB;AAnGM;EAAU,mBCraI;AD2gBpB;AAjGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBC/Xe;EDgYf,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cCragB;EDsahB,eChXmB;EDiXnB,gBAAA;EACA,0BAAA;AAmGJ;AAjGI;EAAmB,cCvZD;AD2ftB;AAlGI;EACE,cCjcc;EDkcd,mBChcc;ADoiBpB;AAnGM;EAAmB,cC7ZH;ED6ZsB,mBC9ZtB;ADqgBtB;AAlGE;EACE,kBAAA;AAoGJ;AA/FE;EAAmB,iBAAA;AAkGrB;AAhGE;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBC/Ze;EDgaf,0CCvZa;EDwZb,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;AAkGJ;AAhGI;EAAgB,WAAA;EAAa,OAAA;AAoGjC;AAlGI;EACE,mBC7bgB;ED8bhB,qBCzbgB;ED0bhB,yCC/ZW;ADmgBjB;AA/FE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBC5egB;ED6ehB,YAAA;EACA,eCpamB;EDqanB,gBAAA;AAiGJ;AA/FI;EAAM,aAAA;AAkGV;AA/FE;EACE,aAAA;EACA,qDAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAiGJ;AA/FI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,4CAAA;AAiGN;AA7FM;EAAQ,gBAAA;EAAkB,eC9bT;ED8bqC,gBAAA;AAkG5D;AAjGM;EAAQ,eCjcS;EDiciB,YAAA;EAAc,yBAAA;EAA2B,sBAAA;EAAwB,eAAA;AAwGzG;AApGE;EACE,YAAA;AAsGJ;AApGI;EACE,eAAA;EACA,gBAAA;EACA,cC/fc;EDggBd,sBAAA;EACA,yBAAA;EACA,oBAAA;AAsGN;AApGM;EAAmB,cClfH;ADylBtB;AAnGE;EACE,WAAA;EACA,mBCvgBgB;EDwgBhB,aAAA;AAqGJ;AAnGI;EAAmB,mBC1fD;ADgmBtB;AAnGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,cCxhBgB;EDyhBhB,eClemB;EDmenB,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;AAqGJ;AAnGI;EAAmB,cChhBD;ADsnBtB;AApGI;EACE,mBCvjBc;EDwjBd,cC1jBc;ADgqBpB;AArGM;EAAmB,mBCthBH;EDshBoC,cCrhBpC;AD8nBtB;AAtGI;EACE,cCniBc;AD2oBpB;AAvGM;EAAmB,cAAA;AA0GzB;AAzGM;EAAU,mCAAA;EAAsC,cCriBlC;ADkpBpB;AAxGE;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,QAAA;AA0GJ;AAxGI;EAAO,gBAAA;EAAkB,kBAAA;AA4G7B;AA3GI;EAAQ,gBAAA;AA8GZ;AA7GI;EAAQ,eCrgBW;EDqgBe,cCzjBlB;AD0qBpB;AAjH0D;EAAmB,cCviBvD;AD2pBtB;AAnHI;EAAS,cC1kBO;ED0kBa,gBAAA;AAuHjC;AApHE;EACE,mBCjlBgB;ADusBpB;AArHI;EAAmB,mBC/iBD;ADuqBtB;AApHE;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,cCzkBgB;ED0kBhB,eAAA;EACA,YAAA;EACA,kBAAA;AAsHJ;AArHI;EAAmB,cC1jBD;ADkrBtB;AAvHI;EATF;IAS8B,aAAA;EA2H9B;AACF;AAxHE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA0HJ;AAxHI;EALF;IAMI,kBAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,sBAAA;IACA,oBAAA;IACA,iBAAA;IACA,gCAAA;IACA,sBAAA;IACA,QAAA;IACA,aAAA;IACA,0CCvjBW;EDkrBf;EAzHI;IAAU,aAAA;EA4Hd;EA1HI;IACE,mBCxlBc;IDylBd,4BCplBc;EDgtBpB;EAzHI;IACE,gBAAA;IACA,yBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBC9kBW;EDysBjB;EAxHI;IAAyB,cAAA;EA2H7B;AACF;AAjcA;EA0UE,gBAAA;EACA,MAAA;AA0HF;;AAvHA;EACE;IAAO,UAAA;IAAY,2BAAA;EA4HnB;EA3HA;IAAO,UAAA;IAAY,wBAAA;EA+HnB;AACF;AA1HE;EAAW,eAAA;EAAiB,iBAAA;AA8H9B;AA7HE;EAAW,cAAA;AAgIb;AA/HE;EAAiC,iBAAA;AAkInC;;AA7HE;EAAiB,kBAAA;AAiInB;AAhIE;EAAiB,SAAA;AAmInB;AAlIE;EAAyB,iBAAA;AAqI3B;AAnIE;EACE;IAAiB,kBAAA;EAsInB;EArIE;IAAyB,cAAA;EAwI3B;AACF;;AApIA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,qBAAA;EACA,6BAAA;AAuIF;AArIE;EACE,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAuIJ;AApIE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;AAsIJ;AAnIE;EAAiB,kBAAA;AAsInB;AArIE;EAAiB,SAAA;EAAS,YAAA;EAAc,SAAA;AA0I1C;AAzIE;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA2IJ;AAzIE;EAAwB,cAAA;AA4I1B;AA3IE;;EAEE,uBAAA;EACA,cAAA;EACA,gBAAA;AA6IJ;AA3IE;EACE,sBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,wCAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AA6IJ;AA3IE;EAAqB,mBAAA;EAAqB,cAAA;AA+I5C;AA7IE;EA7DF;IA8DI,YAAA;IACA,gBAAA;EAgJF;EA/IE;IAAa,kBAAA;EAkJf;EAjJE;IAAiB,YAAA;EAoJnB;EAnJE;IAAiB,kBAAA;EAsJnB;EArJE;IAAiB,SAAA;EAwJnB;EAvJE;IAAe,WAAA;IAAa,gBAAA;EA2J9B;AACF","sourcesContent":["@import '../styles/variables';\n\n// ── Navbar ─────────────────────────────────────────────────────────────────────\n.navbar {\n  position: sticky;\n  top: 0;\n  z-index: 900;\n  background: #fff;\n  border-bottom: 1px solid #EBEBEB;\n  transition: box-shadow 0.2s ease;\n\n  &.scrolled { box-shadow: 0 2px 12px rgba(0,0,0,0.08); }\n\n  body.dark-mode & {\n    background: #111827;\n    border-bottom-color: #1F2937;\n  }\n\n  .container { padding-top: 0; padding-bottom: 0; }\n\n  &__inner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 72px;\n    gap: 24px;\n  }\n\n  // ── Brand ──────────────────────────────────────────────────────────────────\n  &__brand {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    text-decoration: none;\n    flex-shrink: 0;\n  }\n\n  &__logo {\n    height: 32px;\n    width: auto;\n  }\n\n  &__brand-name {\n    font-size: 18px;\n    font-weight: 800;\n    color: $primary-color;\n    letter-spacing: -0.03em;\n\n    body.dark-mode & { color: #F9FAFB; }\n  }\n\n  // ── Nav links (desktop center) ─────────────────────────────────────────────\n  &__links {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-left: auto;\n\n    @media (max-width: 900px) {\n      display: none;\n      position: fixed;\n      inset: 72px 0 0 0;\n      background: #fff;\n      flex-direction: column;\n      align-items: stretch;\n      padding: 16px;\n      gap: 4px;\n      overflow-y: auto;\n      border-top: 1px solid #EBEBEB;\n      z-index: 900;\n\n      body.dark-mode & { background: #111827; border-top-color: #1F2937; }\n\n      &--open { display: flex; }\n    }\n  }\n\n  &__link {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #374151;\n    text-decoration: none;\n    transition: background 0.15s, color 0.15s;\n    white-space: nowrap;\n\n    &:hover { background: #F3F4F6; color: $primary-color; }\n\n    body.dark-mode & { color: #D1D5DB; &:hover { background: #1F2937; color: #F9FAFB; } }\n\n    @media (max-width: 900px) {\n      padding: 12px 16px;\n      border-radius: 10px;\n      font-size: 15px;\n    }\n  }\n\n  // ── Action buttons (currency, lang, dark) ──────────────────────────────────\n  &__icon-btn {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 8px 12px;\n    border: none;\n    border-radius: 8px;\n    background: transparent;\n    font-size: 13px;\n    font-weight: 500;\n    color: #374151;\n    cursor: pointer;\n    transition: background 0.15s, color 0.15s;\n    white-space: nowrap;\n\n    &:hover { background: #F3F4F6; color: $primary-color; }\n\n    body.dark-mode & { color: #D1D5DB; &:hover { background: #1F2937; color: #F9FAFB; } }\n\n    @media (max-width: 900px) {\n      padding: 12px 16px;\n      border-radius: 10px;\n      font-size: 15px;\n      width: 100%;\n      justify-content: flex-start;\n    }\n  }\n\n  &__user-trigger {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 156px;\n    padding: 5px 8px;\n    border: 1px solid $border-color;\n    border-radius: 24px;\n    background: #f8fafc;\n    color: $text-color;\n    cursor: pointer;\n    text-align: left;\n  }\n\n  &__user-avatar { display: grid; width: 32px; height: 32px; flex: 0 0 32px; place-items: center; border-radius: 50%; background: $primary-light; color: $primary-color; font-size: 11px; font-weight: 750; }\n  &__user-copy { display: flex; min-width: 0; flex: 1; flex-direction: column; line-height: 1.2; }\n  &__user-copy strong, &__user-copy small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n  &__user-copy strong { font-size: 12px; font-weight: 650; }\n  &__user-copy small { margin-top: 2px; color: $text-muted; font-size: 9px; }\n\n  // ── CTA Button ─────────────────────────────────────────────────────────────\n  &__cta {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 9px 18px;\n    border: none;\n    border-radius: 8px;\n    background: $primary-color;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s, transform 0.1s;\n    white-space: nowrap;\n\n    &:hover { background: darken($primary-color, 8%); }\n    &:active { transform: scale(0.98); }\n\n    @media (max-width: 900px) { width: 100%; justify-content: center; padding: 13px 18px; font-size: 15px; }\n  }\n\n  // ── Dropdown wrapper ────────────────────────────────────────────────────────\n  &__dropdown {\n    position: relative;\n\n    @media (max-width: 900px) { width: 100%; }\n  }\n\n  // ── Dropdown panel ──────────────────────────────────────────────────────────\n  &__panel {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    min-width: 220px;\n    background: #fff;\n    border: 1px solid #E5E7EB;\n    border-radius: 14px;\n    box-shadow: 0 8px 40px rgba(0,0,0,0.14);\n    overflow: hidden;\n    animation: panelIn 0.15s ease;\n    z-index: 999;\n\n    body.dark-mode & { background: #1F2937; border-color: #374151; }\n\n    @keyframes panelIn {\n      from { opacity: 0; transform: translateY(-6px); }\n      to   { opacity: 1; transform: translateY(0); }\n    }\n\n    @media (max-width: 900px) {\n      position: static;\n      box-shadow: none;\n      border: 1px solid #E5E7EB;\n      border-radius: 10px;\n      margin-top: 4px;\n      animation: none;\n    }\n  }\n\n  &__panel--user-menu { min-width: 230px; border-radius: 14px; }\n  &__panel--user-menu .navbar__panel-section { padding: 6px; }\n  &__panel--user-menu .navbar__panel-item { min-height: 42px; padding: 10px 12px; border-radius: 8px; font-size: 13px; }\n\n  &__panel-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 14px 16px 10px;\n    font-size: 13px;\n    font-weight: 700;\n    color: #111827;\n    border-bottom: 1px solid #F3F4F6;\n\n    body.dark-mode & { color: #F9FAFB; border-bottom-color: #374151; }\n  }\n\n  &__panel-user {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 16px;\n    border-bottom: 1px solid #F3F4F6;\n\n    body.dark-mode & { border-bottom-color: #374151; }\n\n    .avatar {\n      width: 38px; height: 38px;\n      border-radius: 50%;\n      background: $primary-color;\n      display: flex; align-items: center; justify-content: center;\n      flex-shrink: 0;\n    }\n\n    .info {\n      .name { font-size: 14px; font-weight: 600; color: #111827; body.dark-mode & { color: #F9FAFB; } }\n      .role { font-size: 11px; color: #6B7280; text-transform: capitalize; body.dark-mode & { color: #9CA3AF; } }\n    }\n  }\n\n  &__panel-section {\n    padding: 6px;\n  }\n\n  &__panel-section-title {\n    padding: 6px 10px 4px;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: #9CA3AF;\n  }\n\n  &__panel-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 9px 10px;\n    border: none;\n    border-radius: 8px;\n    background: transparent;\n    font-size: 13.5px;\n    font-weight: 500;\n    color: #374151;\n    text-decoration: none;\n    cursor: pointer;\n    transition: background 0.12s;\n\n    &:hover { background: #F9FAFB; }\n    body.dark-mode & { color: #D1D5DB; &:hover { background: #111827; } }\n\n    &--active { background: $primary-light; color: $primary-color; font-weight: 600; }\n\n    &--danger { color: #DC2626; &:hover { background: #FEF2F2; } }\n  }\n\n  &__currency-item {\n    justify-content: flex-start;\n    gap: 8px;\n\n    .sym { font-size: 13px; font-weight: 700; color: $gold-color; min-width: 20px; }\n    .code { font-weight: 600; font-size: 13px; }\n    .name { font-size: 12px; color: #9CA3AF; flex: 1; }\n    .check { margin-left: auto; color: $success-color; font-weight: 700; }\n  }\n\n  &__panel-divider {\n    height: 1px;\n    background: #F3F4F6;\n    margin: 4px 0;\n\n    body.dark-mode & { background: #374151; }\n  }\n\n  // ── Mobile toggle ───────────────────────────────────────────────────────────\n  &__mobile-toggle {\n    display: none;\n    border: none;\n    background: transparent;\n    color: #374151;\n    cursor: pointer;\n    padding: 6px;\n    border-radius: 8px;\n    transition: background 0.15s;\n\n    &:hover { background: #F3F4F6; }\n\n    body.dark-mode & { color: #D1D5DB; }\n\n    @media (max-width: 900px) { display: flex; align-items: center; }\n  }\n}\n\n\n.navbar {\n  position: sticky;\n  top: 0;\n  z-index: 200;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-bottom: 1px solid $border-color;\n  transition: $theme-transition;\n\n  body.dark-mode & {\n    background: rgba(9, 17, 30, 0.97);\n    border-bottom-color: $dark-border;\n  }\n\n  .container { padding-top: 0; padding-bottom: 0; }\n\n  // ── Inner layout\n  &__inner {\n    display: flex;\n    align-items: center;\n    height: 64px;\n    gap: 4px;\n  }\n\n  // ── Brand\n  &__brand {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    text-decoration: none;\n    flex-shrink: 0;\n    margin-right: auto;\n    transition: opacity $transition;\n    &:hover { opacity: 0.85; }\n  }\n\n  &__logo {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n  }\n\n  &__brand-name {\n    font-size: 1.15rem;\n    font-weight: 800;\n    letter-spacing: -0.03em;\n    color: $primary-color;\n    body.dark-mode & { color: $gold-color; }\n  }\n\n  // ── Nav links\n  &__link {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 7px 12px;\n    border-radius: $border-radius;\n    color: $text-gray;\n    font-size: $font-size-sm;\n    font-weight: 500;\n    text-decoration: none;\n    background: none;\n    border: none;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: all $transition;\n\n    body.dark-mode & { color: $dark-text-secondary; }\n\n    &:hover {\n      color: $primary-color;\n      background: $primary-light;\n      body.dark-mode & { color: $dark-text; background: $dark-surface-hover; }\n    }\n\n    svg { flex-shrink: 0; }\n  }\n\n  // ── CTA auth button\n  &__cta {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 18px;\n    border-radius: $border-radius;\n    background: $primary-color;\n    color: white;\n    font-size: $font-size-sm;\n    font-weight: 600;\n    letter-spacing: 0.01em;\n    border: none;\n    cursor: pointer;\n    transition: all $transition;\n    white-space: nowrap;\n\n    &:hover {\n      background: $gold-color;\n      box-shadow: $shadow-gold;\n      transform: translateY(-1px);\n    }\n\n    body.dark-mode & {\n      background: $gold-color;\n      color: $primary-color;\n      &:hover { background: $gold-hover; }\n    }\n  }\n\n  // ── Icon button (currency, lang, dark)\n  &__icon-btn {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 7px 10px;\n    border-radius: $border-radius;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: $text-gray;\n    font-size: $font-size-sm;\n    font-weight: 500;\n    transition: all $transition;\n\n    body.dark-mode & { color: $dark-text-secondary; }\n\n    &:hover {\n      color: $primary-color;\n      background: $primary-light;\n      body.dark-mode & { color: $dark-text; background: $dark-surface-hover; }\n    }\n  }\n\n  // ── Dropdown panel (shared)\n  &__dropdown {\n    position: relative;\n  }\n\n  // Give the primary authentication action a deliberate separation from the\n  // utility controls (including the dark-mode switch) on desktop.\n  &__auth-dropdown { margin-left: 10px; }\n\n  &__panel {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    background: white;\n    border: 1px solid $border-color;\n    border-radius: $border-radius-lg;\n    box-shadow: $shadow-lg;\n    z-index: 500;\n    overflow: hidden;\n    animation: navDropdown 0.15s ease;\n    min-width: 240px;\n\n    [dir=\"rtl\"] & { right: auto; left: 0; }\n\n    body.dark-mode & {\n      background: $dark-surface;\n      border-color: $dark-border;\n      box-shadow: $shadow-dark-md;\n    }\n  }\n\n  // Panel header (navy bar)\n  &__panel-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 14px 16px;\n    background: $primary-color;\n    color: white;\n    font-size: $font-size-sm;\n    font-weight: 600;\n\n    svg { opacity: 0.85; }\n  }\n\n  &__panel-user {\n    padding: 16px;\n    background: linear-gradient(135deg, $primary-color, $primary-hover);\n    color: white;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      background: rgba(255,255,255,0.15);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n      border: 1.5px solid rgba(255,255,255,0.3);\n    }\n\n    .info {\n      .name { font-weight: 600; font-size: $font-size-base; line-height: 1.3; }\n      .role { font-size: $font-size-xs; opacity: 0.7; text-transform: uppercase; letter-spacing: 0.08em; margin-top: 2px; }\n    }\n  }\n\n  &__panel-section {\n    padding: 8px;\n\n    &-title {\n      font-size: 10px;\n      font-weight: 700;\n      color: $text-muted;\n      letter-spacing: 0.08em;\n      text-transform: uppercase;\n      padding: 6px 8px 4px;\n\n      body.dark-mode & { color: $dark-text-secondary; }\n    }\n  }\n\n  &__panel-divider {\n    height: 1px;\n    background: $border-color;\n    margin: 4px 0;\n\n    body.dark-mode & { background: $dark-border; }\n  }\n\n  &__panel-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 9px 10px;\n    border-radius: 8px;\n    color: $text-color;\n    font-size: $font-size-sm;\n    font-weight: 500;\n    text-decoration: none;\n    background: none;\n    border: none;\n    width: 100%;\n    cursor: pointer;\n    transition: all $transition;\n    white-space: nowrap;\n\n    body.dark-mode & { color: $dark-text; }\n\n    &:hover {\n      background: $primary-light;\n      color: $primary-color;\n      body.dark-mode & { background: $dark-surface-hover; color: $dark-text; }\n    }\n\n    &--danger {\n      color: $error-color;\n      body.dark-mode & { color: #f87171; }\n      &:hover { background: rgba($error-color, 0.06); color: $error-color; }\n    }\n  }\n\n  // Currency item (wider columns)\n  &__currency-item {\n    display: grid;\n    grid-template-columns: 26px 44px 1fr 18px;\n    align-items: center;\n    gap: 8px;\n\n    .sym { font-weight: 700; font-size: 0.95rem; }\n    .code { font-weight: 600; }\n    .name { font-size: $font-size-xs; color: $text-muted; body.dark-mode & { color: $dark-text-secondary; } }\n    .check { color: $gold-color; font-weight: 700; }\n  }\n\n  &__panel-item--active {\n    background: $primary-light;\n    body.dark-mode & { background: $dark-surface-hover; }\n  }\n\n  // ── Mobile toggle\n  &__mobile-toggle {\n    display: none;\n    background: none;\n    border: none;\n    color: $text-color;\n    cursor: pointer;\n    padding: 6px;\n    border-radius: 8px;\n    body.dark-mode & { color: $dark-text; }\n    @media (max-width: 768px) { display: flex; }\n  }\n\n  // ── Nav items wrapper\n  &__links {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n\n    @media (max-width: 768px) {\n      position: absolute;\n      top: 64px;\n      left: 0;\n      right: 0;\n      flex-direction: column;\n      align-items: stretch;\n      background: white;\n      border-bottom: 1px solid $border-color;\n      padding: $spacing-sm $spacing-md $spacing-md;\n      gap: 2px;\n      display: none;\n      box-shadow: $shadow-md;\n\n      &--open { display: flex; }\n\n      body.dark-mode & {\n        background: $dark-surface;\n        border-bottom-color: $dark-border;\n      }\n\n      .navbar__panel {\n        position: static;\n        border: 1px solid $border-color;\n        box-shadow: none;\n        margin-top: 4px;\n        border-radius: $border-radius;\n      }\n\n      .navbar__auth-dropdown { margin-left: 0; }\n    }\n  }\n\n  // Make navbar position relative for mobile dropdown\n  position: sticky;\n  top: 0;\n}\n\n@keyframes navDropdown {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n// The document direction is managed centrally by i18n. Use logical placement\n// here so the complete header mirrors when Arabic is selected.\nhtml[dir='rtl'] .navbar {\n  &__brand { margin-right: 0; margin-left: auto; }\n  &__links { direction: rtl; }\n  &__panel-item, &__panel-header { text-align: start; }\n}\n\n// Keep primary navigation beside the brand and push account utilities right.\n.navbar.navbar--authenticated {\n  .navbar__brand { margin-right: 24px; }\n  .navbar__links { flex: 1; }\n  .navbar__utility-start { margin-left: auto; }\n\n  @media (max-width: 768px) {\n    .navbar__brand { margin-right: auto; }\n    .navbar__utility-start { margin-left: 0; }\n  }\n}\n\n// Public landing header measurements from the approved reference frame.\n.navbar.navbar--reference {\n  box-sizing: border-box;\n  width: 100%;\n  height: 96px;\n  min-height: 96px;\n  background: #fff;\n  border-bottom: 1px solid #ebebeb;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n\n  .container {\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 1440px;\n    padding: 24px 32px;\n  }\n\n  .navbar__inner {\n    width: 100%;\n    max-width: 1376px;\n    height: 48px;\n    gap: 10px;\n    justify-content: space-between;\n  }\n\n  .navbar__brand { margin-right: 30px; }\n  .navbar__links { flex: 1; height: 48px; gap: 40px; }\n  .navbar__link {\n    height: 48px;\n    padding: 15px 0;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 18px;\n  }\n  .navbar__link--active { color: #2E8CC9; }\n  .navbar__link:hover,\n  .navbar__link:focus-visible {\n    background: transparent;\n    color: #2E8CC9;\n    box-shadow: none;\n  }\n  .navbar__cta {\n    box-sizing: border-box;\n    width: 137px;\n    height: 48px;\n    min-height: 48px;\n    margin-left: auto;\n    padding: 16px 24px;\n    gap: 10px;\n    border-radius: 100px;\n    background: var(--CS-Blue-main, #2E86C9);\n    color: #FFFFFF;\n    font-family: Inter, sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0;\n    text-align: center;\n  }\n  .navbar__cta:hover { background: #2477B7; color: #FFFFFF; }\n\n  @media (max-width: 768px) {\n    height: 72px;\n    min-height: 72px;\n    .container { padding: 12px 20px; }\n    .navbar__inner { height: 48px; }\n    .navbar__brand { margin-right: auto; }\n    .navbar__links { top: 72px; }\n    .navbar__cta { width: 100%; min-height: 44px; }\n  }\n}","﻿// --- Yet2Book Design System --- Royal Navy x Warm Gold -----------------------\n\n// -- Brand Palette -------------------------------------------------------------\n$primary-color:     #1B2B4B;\n$primary-hover:     #0F1C32;\n$primary-light:     #EEF2F8;\n$primary-border:    #C4CDD8;\n\n$gold-color:        #C9A84C;\n$gold-hover:        #B8953D;\n$gold-light:        #FDF8EE;\n$gold-border:       #E8D5A3;\n\n$secondary-color:   #0F1C32;\n$accent-color:      #EEF2F8;\n\n// -- Surfaces ------------------------------------------------------------------\n$background-light:  #F7F8FA;\n$surface-white:     #FFFFFF;\n$surface-off:       #FAFBFD;\n\n// -- Typography ----------------------------------------------------------------\n$text-color:        #0F1C32;\n$text-gray:         #64748B;\n$text-muted:        #94A3B8;\n\n// -- Borders -------------------------------------------------------------------\n$border-color:      #E2E8F0;\n$border-strong:     #CBD5E1;\n\n// -- Semantic ------------------------------------------------------------------\n$error-color:       #DC2626;\n$success-color:     #16A34A;\n$warning-color:     #D97706;\n$info-color:        #2563EB;\n\n// -- Dark Mode -----------------------------------------------------------------\n$dark-bg:             #09111E;\n$dark-surface:        #0F1C32;\n$dark-surface-2:      #162444;\n$dark-surface-hover:  #1E2F4D;\n$dark-text:           #F1F5F9;\n$dark-text-secondary: #94A3B8;\n$dark-border:         #1E3055;\n$dark-input-bg:       #0B1527;\n$dark-input-border:   #263A5E;\n$dark-shadow:         rgba(0, 0, 0, 0.8);\n\n// -- Spacing -------------------------------------------------------------------\n$spacing-xs:  4px;\n$spacing-sm:  8px;\n$spacing-md:  16px;\n$spacing-lg:  24px;\n$spacing-xl:  40px;\n$spacing-xxl: 64px;\n\n// -- Layout --------------------------------------------------------------------\n$border-radius:    10px;\n$border-radius-lg: 16px;\n$border-radius-xl: 24px;\n$transition:       0.18s ease;\n$theme-transition: all 0.25s ease;\n\n// -- Shadows -------------------------------------------------------------------\n$shadow-xs:      0 1px 3px rgba(0, 0, 0, 0.06);\n$shadow-sm:      0 2px 8px rgba(0, 0, 0, 0.07);\n$shadow-md:      0 4px 20px rgba(0, 0, 0, 0.09);\n$shadow-lg:      0 8px 40px rgba(0, 0, 0, 0.12);\n$shadow-xl:      0 16px 64px rgba(0, 0, 0, 0.16);\n$shadow-focus:   0 0 0 3px rgba(201, 168, 76, 0.28);\n$shadow-dark-md: 0 4px 24px rgba(0, 0, 0, 0.6);\n$shadow-gold:    0 4px 20px rgba(201, 168, 76, 0.35);\n\n// -- Typography ----------------------------------------------------------------\n$font-family:          'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n$font-family-display:  'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n$font-size-xs:         11px;\n$font-size-sm:         13px;\n$font-size-base:       15px;\n$font-size-lg:         16px;\n$font-size-xl:         18px;\n$font-size-xxl:        24px;\n$font-size-xxxl:       32px;\n$font-weight-normal:   400;\n$font-weight-medium:   500;\n$font-weight-semibold: 600;\n$font-weight-bold:     700;\n$font-weight-black:    800;\n\n// -- Legacy Aliases ------------------------------------------------------------\n$light-gray:  $accent-color;\n$text-dark:   $text-color;\n$ocean-blue:  $primary-color;\n$ocean-light: $primary-light;\n$radius-sm:   6px;\n$radius-md:   $border-radius;\n$radius-lg:   $border-radius-lg;\n\n// -- Admin Sidebar -------------------------------------------------------------\n$admin-sidebar-width:         240px;\n$admin-sidebar-collapsed-width: 64px;\n$admin-topbar-height:         60px;\n\n$admin-sidebar-bg:            #0B1527;\n$admin-sidebar-border:        #1A2E4A;\n$admin-sidebar-text:          #94A3B8;\n$admin-sidebar-text-hover:    #CBD5E1;\n$admin-sidebar-active:        #FFFFFF;\n$admin-sidebar-active-bg:     rgba(37, 99, 235, 0.18);\n$admin-sidebar-active-border: #2563EB;\n$admin-sidebar-icon:          #64748B;\n$admin-sidebar-icon-active:   #2563EB;\n$admin-sidebar-badge:         #EF4444;\n\n$admin-topbar-bg:             #FFFFFF;\n$admin-topbar-border:         #E2E8F0;\n$admin-topbar-shadow:         0 1px 3px rgba(0,0,0,0.08);\n\n$admin-content-bg:            #F1F5F9;\n$admin-card-bg:               #FFFFFF;\n$admin-card-shadow:           0 1px 4px rgba(0,0,0,0.06);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
